export const slackRequiredScopes = [
    'links:read',
    'links:write',
    'chat:write',
    'chat:write.customize',
    'channels:read',
    'channels:join',
    'groups:read',
    'users:read',
    'app_mentions:read',
    'files:write',
    'files:read',
];
//# sourceMappingURL=slackSettings.js.map